<template>
  <div
    id="main"
    :style="{ 'margin-bottom': displayNewDashboard ? '0px' : '30px' }"
  >
    <navigation ref="nav" />
    <window-resize />
    <transition name="slide">
      <div v-if="isNavOpened">
        <sidebar ref="sidebar" />
      </div>
    </transition>
    <!-- Page Content -->
    <div v-if="isSearchOpened" class="blured-body" />
    <main
      class="page-content"
      :style="pageContentStyle"
      :class="{ 'mobile-responsive': isMobile }"
    >
      <router-view />
      <div v-if="false">
        <fab v-if="canShowHelpFab" :draggable="true" :items="fabItems" />
      </div>
      <Chat
        v-if="canShowChatFab"
        token="apvVZ6ca83w.dvEGCvaHLpjTcEfISXUgt8cSovzXWP0Fy3O9hkSDshY"
        :show-prop-chat="showChat"
        @hideChat="hideChat"
        :profile="profile"
      />
    </main>
  </div>
</template>

<script>
import Navigation from "./Navigation";
import Sidebar from "./Sidebar";
import store from "@/store/index";
import WindowResize from "./components/WindowResize";
import alert from "@/mixin/alert.mixin";
import Fab from "custom-floating-action-button";
import Chat from "@/components/Chat";
import "@/assets/css/all.css";
import "@/assets/css/solid.css";
import "@/assets/css/style.css";
import "@/assets/css/mobile.css";
import { getSysparameterByNames } from "@/modules/system-parameter-managment/api";

const TICKETS_ROUTE_NAME = "CaseListMain";
const GUIDE_ROUTE_NAME = "";

export default {
  components: {
    navigation: Navigation,
    sidebar: Sidebar,
    WindowResize,
    Fab,
    Chat
  },
  mixins: [alert],
  data() {
    return {
      showChat: false,
      canShowBot: false,
      hasStudentSelected: store.state.$_student.selectedStudent == null,
      studentAlertMessage:
        "Favor de seleccionar un estudiante antes de entrar a esta pantalla",
      windowWidth: 0,
      sessionExpired: false,
      displayNewDasboardParameterValue: false,
      fabItems: [
        {
          label: "Mesa de Apoyo",
          icon: "fal fa-user-headset",
          styles: {
            background: "#2DB782",
            color: "#fff"
          },
          route: TICKETS_ROUTE_NAME
        },
        {
          label: "Guías y Videos",
          icon: "fal fa-globe",
          styles: {
            background: "#fff",
            color: "#2DB782"
          },
          route: GUIDE_ROUTE_NAME
        }
      ]
    };
  },
  computed: {
    displayNewDashboard() {
      return this.$route.path == "/" && this.displayNewDasboardParameterValue;
    },
    canShowChatFab() {
      return this.canShowBot && this.profile;
    },
    canShowHelpFab() {
      return this.$store.getters.HasPermission("academic.helpfab.view");
    },
    isNavOpened() {
      return store.getters.getIsNavOpen;
    },
    isMobile() {
      return store.getters.getIsMobileDensity;
    },
    // Panel docked del Asistente de IA del PEI (AiAssistantModal.vue) -- cuando está
    // abierto en modo docked, angosta el área de contenido principal para que el panel
    // ocupe el lado derecho sin superponerse (ver pageContentStyle()).
    isAiAssistantDocked() {
      return store.getters.getIsAiAssistantDocked;
    },
    // Ancho del panel docked: sale de la variable CSS global --ai-assistant-panel-width
    // (definida en assets/scss/v2/main.scss), la misma que usan .ai-modal--docked y
    // navStyle() en Navigation.vue -- antes el 440px estaba repetido a mano en los tres.
    pageContentStyle() {
      const style = this.displayNewDashboard
        ? { 'background-color': '#F1F6F4' }
        : {};
      style['transition'] = 'margin-right 0.22s ease';
      style['margin-right'] = this.isAiAssistantDocked
        ? 'var(--ai-assistant-panel-width)'
        : '0px';
      return style;
    },
    showRequiredStudentModal() {
      return store.state.showRequiredStudentModal;
    },
    studentSelected() {
      return store.state.$_student.selectedStudent;
    },
    isSearchOpened() {
      return store.state.$_student.searchOpened;
    },
    profile() {
      return {
        userId: this.userProfile.sub,
        firstname: this.userProfile.firstname
      };
    }
  },
  watch: {
    studentSelected(newValue) {
      this.hasStudentSelected = newValue == null;
    },
    sessionExpired(newValue) {
      if (newValue) {
        this.showCloseAlert();
      }
    }
  },
  methods: {
    async getSysParam() {
      const { data: sysParameters } = await getSysparameterByNames({
        parameterNames: ["ChatBotAvailable"]
      });
      this.canShowBot =
        sysParameters[0].staticValue == "True" &&
        this.$store.getters.HasPermission("operations.chatbotbtn");

      if (this.canShowBot) {
        this.fabItems.push({
          label: "Asistente Virtual",
          icon: "fal fa-comment",
          styles: {
            background: "#fff",
            color: "#2DB782"
          },
          action: this.showBotChat
        });
      }
    },
    showBotChat() {
      this.showChat = true;
    },
    hideChat() {
      this.showChat = false;
    },
    async showCloseAlert() {
      this.ShowAlert(
        "La sesión ha expirado",
        "Debe iniciar sesión nuevamente para continuar.",
        "error",
        async () => {
          await store.dispatch("$_user/logout");
        }
      );
    },
    onCloseSidebar() {
      if (store.state.isMobileDensity) {
        store.commit("toggleNav");
      }
    },
    activateActivityTracker() {
      window.addEventListener("mousemove", this.userActivityThrottler);
      window.addEventListener("scroll", this.userActivityThrottler);
      window.addEventListener("keydown", this.userActivityThrottler);
      window.addEventListener("resize", this.userActivityThrottler);
      window.addEventListener("beforeunload", this.deactivateActivityTracker);
    },
    deActivateActivityTracker() {
      window.removeEventListener("mousemove", this.userActivityThrottler);
      window.removeEventListener("scroll", this.userActivityThrottler);
      window.removeEventListener("keydown", this.userActivityThrottler);
      window.removeEventListener("resize", this.userActivityThrottler);
      window.removeEventListener(
        "beforeunload",
        this.deactivateActivityTracker
      );
    },
    userActivityThrottler() {
      if (!this.sessionExpired) {
        clearTimeout(this.userActivityThrottlerTimeout);
        this.userActivityThrottlerTimeout = setTimeout(() => {
          this.handleSessionExpiration();
          clearTimeout(this.userActivityThrottlerTimeout);
        }, process.env.VUE_APP_SESSION_TIMEOUT * 60000);
      }
    },
    async handleSessionExpiration() {
      this.sessionExpired = true;
      await store.commit("$_user/SET_USER_LOGOUT");
    }
  },
  beforeDestroy() {
    window.removeEventListener("mousemove", this.userActivityThrottler);
    window.removeEventListener("scroll", this.userActivityThrottler);
    window.removeEventListener("keydown", this.userActivityThrottler);
    window.removeEventListener("resize", this.userActivityThrottler);
    clearTimeout(this.userActivityThrottlerTimeout);
  },
  async mounted() {
    const { data } = await getSysparameterByNames({
      parameterNames: ["DisplayNewDashboard"]
    });

    this.displayNewDasboardParameterValue =
      data?.length > 0 && data[0].staticValue?.toLowerCase() == "true";

    this.activateActivityTracker();
    if (store.state.$_user.isLoggingOut) {
      this.showCloseAlert();
    }
    window.location.hash = "";
    this.getSysParam();
  }
};
</script>

<style scope>
.blured-body {
  left: 119px;
  top: 100px;
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 11;
}
.blured-body {
  backdrop-filter: blur(8px);
}
/* Red de seguridad: en pantallas angostas el panel docked pasa a ancho completo
   (ver .ai-panel media query en AiAssistantModal.vue), así que el margen que le
   reserva espacio al panel en pageContentStyle() no debe aplicar aquí -- se
   necesita !important porque una regla de hoja de estilos sí puede pisar un
   estilo inline sin !important. */
@media (max-width: 680px) {
  .page-content {
    margin-right: 0 !important;
  }
}
</style>
